export default "__VITE_ASSET__40aa56af__"